import React from 'react';
import LogoImage from './logo.png';

const Logo = () => <img alt='Logo' src={LogoImage} height='50px' />;

export default Logo;
